import React from 'react';
import useCoinshiftHelper from '../../helpers/coinshiftHelper';
import { formatDecimals } from '../../utils';
import './Stats.scss';

const Stats = () => {
  const [userStats] = useCoinshiftHelper();
  return (
    <>
      {+userStats?.tvl_in_usd > 0 ? (
        <div className='main_stats_container'>
          <div className='stats_container'>
            <div className='each'>
              <p>TVL</p>
              <h1>${formatDecimals(userStats?.tvl_in_usd)}</h1>
            </div>
            <div className='each'>
              <p>Points</p>
              <h1>{userStats?.points || 0}</h1>
            </div>
          </div>
          <p>Stats are updated every 24 hours</p>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Stats;
